// extracted by mini-css-extract-plugin
export default {"container":"DetailPreviewDescriptionContainer-module__container--CO++K","withGradientMask":"DetailPreviewDescriptionContainer-module__withGradientMask--Zhct-"};